import React, { useEffect, useState } from 'react';
import apiService from '../../../Services/apiServices';

const AtkPurchaseBookHeader = () => {
    const [vat0, setVat0] = useState([]);
    const [vat18, setVat18] = useState([]);
    const [vat8, setVat8] = useState([]);
    const [filledTable, setFilledTable] = useState(false);

    const getData = async () => {
        const params = `purchaseOrSale=${0}`;

        await apiService().query('getSaleOrPurchase', params)
            .then((response) => {
                if (response.success) {
                    const d = response.data;
                    setVat0(d.filter(f => f.vat === 0));
                    setVat18(d.filter(f => f.vat === 18));
                    setVat8(d.filter(f => f.vat === 8));
                    setFilledTable(true);
                }
            });
    }

    useEffect(() => {
        getData();
    }, []);

    return (
        <tbody>
            <tr height="34" style={{ textAlign: 'center', lineHeight: 1, fontSize: '10pt', fontFamily: 'Arial', fontWeight: 'bold' }}>
                <td height="34" width="39.20" rowSpan="2" style={{ border: '1.0pt solid #000' }}>Nr</td>
                <td width="192" style={{ border: '1.0pt solid #000' }} colSpan="2">Fatura</td>
                <td width="355.93" colSpan="3" style={{ border: '1.0pt solid #000' }}>Shitesi</td>
                <td width={vat0.length * 80} colSpan={vat0.length} style={{ border: '1.0pt solid #000' }}>Blerjet dhe Importet e liruara dhe me TVSH jo te zbritshme</td>
                <td width={vat18.length * 80} colSpan={vat18.length + 1} style={{ border: '1.0pt solid #000' }}>Blerjet dhe importet e tatushme me 18%, si dhe rregullimet e zbritjeve</td>
                <td width={vat8.length * 80} colSpan={vat8.length + 1} style={{ border: '1.0pt solid #000' }}>Blerjet dhe importet e tatushme me 8%, si dhe rregullimet e zbritjeve</td>
                <td width="95.93" rowSpan="2" style={{ border: '1.0pt solid #000', background: '#BFBFBF' }}>Totali i TVSH-se se zbritshme me 18% dhe 8%</td>
            </tr>
            <tr style={{ height: '97px', textAlign: 'center', fontSize: '9pt', fontFamily: 'Arial' }}>
                <td style={{ border: '1.0pt solid #000', padding: 0, marggin: 0 }}>Data</td>
                <td style={{ border: '1.0pt solid #000', padding: 0, marggin: 0 }}>Numri i fatures</td>
                <td style={{ border: '1.0pt solid #000', padding: 0, marggin: 0 }}>Emri i Shit&euml;sit</td>

                <td style={{ border: '1.0pt solid #000', padding: 0, marggin: 0 }}>Numri fiskal i Shit&euml;sit</td>
                <td style={{ border: '1.0pt solid #000', padding: 0, marggin: 0 }}>Numri i TVSH-se se shit&euml;sit</td>
                {vat0.map((item, key) => (
                    <td key={key} style={{ border: '1.0pt solid #000', padding: 0, marggin: 0 }}>{item.name}</td>
                ))}
                {vat18.map((item, key) => (
                    <td key={key} style={{ border: '1.0pt solid #000', padding: 0, marggin: 0 }}>{item.name}</td>
                ))}
                <td style={{ border: '1.0pt solid #000', padding: 0, marggin: 0, backgroundColor: '#CFFFD3' }}>Totali i TVSH-se se zbritshme me 18%</td>
                {vat8.map((item, key) => (
                    <td key={key} style={{ border: '1.0pt solid #000', padding: 0, marggin: 0 }}>{item.name}</td>
                ))}
                <td style={{ border: '1.0pt solid #000', padding: 0, marggin: 0, backgroundColor: '#CFFFD3' }}>Totali i TVSH-se se zbritshme me 8%</td>
                
            </tr>
            <tr style={{ color: 'black', textAlign: 'center', fontSize: '9pt', fontFamily: 'Arial' }}>
                <td style={{ border: '1.0pt solid #000', background: '#BFBFBF', padding: 0, marggin: 0 }} colSpan={6}>Numri i kutise ne deklaraten e TVSH-se</td>
                {vat0.map((item, key) => (
                    <td key={key} style={{ border: '1.0pt solid #000', padding: 0, marggin: 0 }}>{item.number}</td>
                ))}
                {vat18.map((item, key) => (
                    <td key={key} style={{ border: '1.0pt solid #000', padding: 0, marggin: 0 }}>{item.number}</td>
                ))}
                <td style={{ border: '1.0pt solid #000', background: '#BFBFBF', padding: 0, marggin: 0 }}>[K1]</td>
                {vat8.map((item, key) => (
                    <td key={key} style={{ border: '1.0pt solid #000', padding: 0, marggin: 0 }}>{item.number}</td>
                ))}
                <td style={{ border: '1.0pt solid #000', background: '#BFBFBF', padding: 0, marggin: 0 }}>[K2]</td>
                <td style={{ border: '1.0pt solid #000', background: '#BFBFBF', padding: 0, marggin: 0 }}>[67]</td>
            </tr>
        </tbody>
    );
};

export default AtkPurchaseBookHeader;
